// ========== 主入口文件 ==========
// 导入所有模块
import { generateParticles } from './modules/particles.js';
import { initStarSystem } from './modules/stars.js';
import { initWaterRenderer } from './modules/water-canvas.js';
import { initFloatingZoom } from './modules/zoom-control.js';
import { initSmoothScroll, initHeaderScroll, initButtonEvents, initZoomTip } from './modules/navigation.js';
import { initImageLoader } from './modules/image-loader.js';
import { devicePerformance } from './utils/performance.js';

// ========== 性能监控工具（调试模式）==========
function initPerformanceMonitor() {
    if (!window.location.search.includes('perf')) return;

    const perfPanel = document.createElement('div');
    perfPanel.style.cssText = `
        position: fixed;
        top: 80px;
        left: 10px;
        background: rgba(0, 0, 0, 0.8);
        color: #0f0;
        font-family: monospace;
        font-size: 12px;
        padding: 10px;
        border-radius: 5px;
        z-index: 10000;
        line-height: 1.6;
    `;
    document.body.appendChild(perfPanel);

    let frameCount = 0;
    let lastFPSUpdate = performance.now();
    let currentFPS = 0;

    function updatePerfPanel() {
        frameCount++;
        const now = performance.now();
        if (now - lastFPSUpdate >= 1000) {
            currentFPS = Math.round(frameCount * 1000 / (now - lastFPSUpdate));
            frameCount = 0;
            lastFPSUpdate = now;
        }

        const particleCount = document.querySelectorAll('.particle').length;
        const starCount = document.querySelectorAll('.hero-star').length;

        perfPanel.innerHTML = `
            <div style="color: #fff; font-weight: bold; margin-bottom: 5px;">⚡ 性能监控</div>
            <div>设备性能: ${devicePerformance === 'low' ? '🔻 低端' : '✅ 高端'}</div>
            <div>粒子数量: ${particleCount} 个</div>
            <div>星星数量: ${starCount} 个</div>
            <div>实际帧率: <span style="color: ${currentFPS < 24 ? '#f00' : '#0f0'}">${currentFPS} FPS</span></div>
            <div style="margin-top: 5px; color: #888; font-size: 10px;">提示: 使用 ?debug 查看详细日志</div>
        `;
        requestAnimationFrame(updatePerfPanel);
    }
    updatePerfPanel();
}

// ========== 初始化所有模块 ==========
function init() {
    console.log('🚀 初始化应用...');
    
    // 1. 初始化图片加载器（优先加载背景图）
    initImageLoader();
    
    // 2. 生成粒子（必须最先执行）
    generateParticles();
    
    // 3. 初始化星星系统（依赖粒子）
    initStarSystem();
    
    // 4. 初始化 Canvas 渲染
    initWaterRenderer();
    
    // 5. 初始化缩放控制
    initFloatingZoom();
    
    // 6. 初始化导航和交互功能
    initSmoothScroll();
    initHeaderScroll();
    initButtonEvents();
    initZoomTip();
    
    // 7. 初始化性能监控（如果启用）
    initPerformanceMonitor();

    // 8. Hero 幕布动画：1.5s 后图片向右收缩，文字从左滑入
    initHeroReveal();
    
    console.log('✅ 应用初始化完成');
}

// ========== Hero 幕布动画 ==========
function initHeroReveal() {
    const bgImage = document.querySelector('.hero-bg-image');
    const heroContent = document.querySelector('.hero-content');
    if (!bgImage || !heroContent) return;

    let triggered = false;

    function triggerReveal() {
        if (triggered) return;
        triggered = true;
        setTimeout(() => {
            heroContent.classList.add('reveal');
        }, 1500);
    }

    // 轮询检查 loaded 类（image-loader 用 onload 赋值，无法用 addEventListener 监听）
    const checkLoaded = setInterval(() => {
        if (bgImage.classList.contains('loaded')) {
            clearInterval(checkLoaded);
            triggerReveal();
        }
    }, 100);

    // 兜底：最多等 4s，不管图片有没有加载完都触发
    setTimeout(() => {
        clearInterval(checkLoaded);
        triggerReveal();
    }, 4000);
}

// 等待 DOM 加载完成后初始化
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}

// ========== ICP 备案号 - 直接新标签页打开，无动画 ==========
// 备案链接已在 HTML 中设置 target="_blank"，无需额外 JS 处理
